import PageLoader from 'components/PageLoader';
import { useLayoutContext } from 'contexts/LayoutContext';
import { Column } from 'further-ui/components/Layout';
import { useFormContext } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { UpdateCapitalActionFormValues } from '../hooks/useCapitalActionForm';
import InvestorBreakdown from './InvestorBreakdown';
import TransactionsReview from './TransactionsReview';
import useReviewDetails from './hooks/useReviewDetails';
import PageSection from 'components/new/PageSection';
import StaticField from 'further-ui/components/StaticField';

const CapitalActionReview: React.FC = () => {
  const { id } = useParams<{ id?: string }>();
  const { vehicle } = useLayoutContext();

  const { getValues } = useFormContext<UpdateCapitalActionFormValues>();

  const entries = getValues('entries') ?? [];
  const capitalActionName = getValues('name');
  const capitalActionDate = getValues('ledgerDate');
  const capitalActionDueDate = getValues('actionDueDate');

  const { investorsBreakdown, isLoading: isReviewDetailsLoading } =
    useReviewDetails({
      capitalActionId: id,
      entries,
      vehicleId: getValues('vehicleId'),
      date: getValues('ledgerDate'),
    });

  if (isReviewDetailsLoading) {
    return <PageLoader />;
  }

  return (
    <Column spacing="lg">
      <PageSection>
        <StaticField label="Vehicle">{vehicle?.vehicleName}</StaticField>
        <StaticField label="Capital action name">
          {capitalActionName}
        </StaticField>
        <StaticField label="Capital action date">
          {capitalActionDate.toReadable()}
        </StaticField>
        <StaticField label="Capital action due date">
          {capitalActionDueDate.toReadable()}
        </StaticField>
      </PageSection>
      <PageSection title="Capital action breakdown">
        <InvestorBreakdown
          investorsBreakdown={investorsBreakdown}
          baseCurrency={vehicle?.baseCurrency}
        />
      </PageSection>
      <PageSection withoutBottomDivider title="Review accounts transactions">
        <TransactionsReview vehicleId={vehicle?._id ?? ''} />
      </PageSection>
    </Column>
  );
};

export default CapitalActionReview;
